
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/med-solution",
      function () {
        return require("private-next-pages/med-solution.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/med-solution"])
      });
    }
  